var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "wp-contact-list-page" } }, [
    _c("h3", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("wp.contactList"))),
    ]),
    _vm._v(" "),
    _vm.selections.length
      ? _c("div", { staticClass: "selection-bar" }, [
          _c(
            "section",
            { staticClass: "uncheck", on: { click: _vm.unselectAll } },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" arrow_back "),
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("chatbotv2.uncheckAll")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "select", on: { click: _vm.selectAll } },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.selectAll")))]
          ),
          _vm._v(" "),
          _c("section", { staticClass: "queries" }, [
            _vm._v(
              "+" +
                _vm._s(_vm.selections.length) +
                _vm._s(_vm.$t("wp.contactSelected"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "actions" },
            [
              _c(
                "a-button",
                { staticClass: "d-none", attrs: { ghost: "", disabled: "" } },
                [_vm._v(_vm._s(_vm.$t("wp.sendBroadcastMessage")))]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "my-1 wp-list-searching-input" },
      [
        _c("a-input-search", {
          staticClass: "row search-input",
          attrs: { placeholder: _vm.$t("message.startFilter") },
          on: {
            input: function ($event) {
              return _vm.onSearch($event.target.value)
            },
          },
          model: {
            value: _vm.searchText,
            callback: function ($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mr-5" },
          [
            _c("a-button", { on: { click: _vm.showModal } }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("wp.startChatWithAnyNo")) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "a-modal",
              {
                staticClass: "row d-flex flex-row",
                attrs: {
                  "confirm-loading": _vm.confirmLoading,
                  title: _vm.$t("wp.typeInANumberDesc"),
                  visible: _vm.visible,
                },
                on: {
                  cancel: _vm.handleCancel,
                  ok: function ($event) {
                    return _vm.handleOk(_vm.wpContactNumber)
                  },
                },
              },
              [
                _vm.showAlertMessage
                  ? _c(
                      "div",
                      { staticClass: "pb-3" },
                      [
                        _c("a-alert", {
                          attrs: {
                            message: _vm.$t("wp.toLittleChar"),
                            type: "error",
                            banner: "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-row align-items-center justify-content-center",
                  },
                  [
                    _c("vue-country-code", {
                      staticClass: "col-3 country-code",
                      attrs: {
                        defaultCountry: _vm.userLastCountry,
                        enabledCountryCode: true,
                      },
                      on: {
                        onSelect: function ($event) {
                          return _vm.onSelect($event)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8" },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "##########",
                              expression: "'##########'",
                            },
                          ],
                          attrs: {
                            placeholder: _vm.$t("message.phone"),
                            autocomplete: "off",
                            trim: "",
                            type: "text",
                          },
                          model: {
                            value: _vm.wpContactNumber,
                            callback: function ($$v) {
                              _vm.wpContactNumber = $$v
                            },
                            expression: "wpContactNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "a-table",
          {
            key: "vtable-" + _vm.renderCount,
            staticClass: "custom-table",
            attrs: {
              columns: _vm.cols,
              dataSource: _vm.allContacts,
              loading: _vm.loading,
              locale: {
                emptyText: _vm.$t("message.noContactFound"),
              },
              pagination: _vm.pagination,
              "row-selection": {
                onChange: _vm.rowSelectionOnChange,
                selectedRowKeys: _vm.selections,
              },
              rowKey: "id",
              size: "small",
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "avatarSlot",
                fn: function (data, item) {
                  return _c(
                    "div",
                    { staticClass: "p-1" },
                    [
                      _c(
                        "a-avatar",
                        {
                          staticStyle: {
                            "background-color": "#3899ff",
                            "border-radius": "7px !important",
                          },
                          attrs: {
                            size: 30,
                            src: _vm.$_.get(item, "profilePicThumbObj.eurl"),
                            username: item.name,
                            shape: "square",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                item.name.substr(0, 1).toLocaleUpperCase()
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                },
              },
              {
                key: "phoneNumber",
                fn: function (data, item) {
                  return _c("div", { staticClass: "p-1" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(item.phoneNumber.slice(0, -5)) +
                        "\n            "
                    ),
                  ])
                },
              },
              {
                key: "action",
                fn: function (data, item) {
                  return _c("div", {}, [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-end",
                        staticStyle: { "margin-right": "-10px !important" },
                      },
                      [
                        _c(
                          "md-button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                  theme: _vm.isDarkMode
                                    ? "light-border"
                                    : "google",
                                },
                                expression:
                                  "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                              },
                            ],
                            attrs: {
                              id: "joinChat",
                              content: _vm.$t("wp.startChatWp"),
                              "data-v-step": "16",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.startChat(item.phoneNumber)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("wp.startChatWp")) +
                                "\n                        "
                            ),
                            _c(
                              "md-icon",
                              {
                                staticStyle: {
                                  color: "#06e576",
                                  "font-size": "12px",
                                },
                              },
                              [_vm._v(" whatsapp")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "delete-chat",
                            attrs: {
                              id: "deleteChat",
                              content: "Kişiyi Sil",
                              "data-v-step": "16",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteVisitorConfirm(item)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("close"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                },
              },
            ]),
          },
          [_c("div")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }